// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  nemUrl: 'http://104.128.226.60:7890/account/mosaic/owned?',
  // nemUrl: 'http://hugealice.nem.ninja:7890/account/mosaic/owned?',
  testUrl: 'http://104.128.226.60:7890/account/mosaic/owned?',
  production: false
};



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/environments/environment.ts